<div class="comment-header">
	<i class="fas fa-dot-circle"></i>
	<h6 class="comment-date">{{item.created | date: 'medium'}}</h6>
</div>
<div class="comment-body">
	<h5>{{viewMode === VIEW_COMMENTS_MODE.COMMENTS ? 'Comment' : 'Stip'}} {{index + 1}}</h5>
	<input type="checkbox"
				 name="stip-select-{{item.id}}"
				 id="stip-select-{{item.id}}"
				 (change)="onValueChange($event)">
	<p class="block-with-text" [ngClass]="{'block-with-text--more': viewMore}" [innerHTML]="text | safeHtml">
  </p>
  <a href="javascript:void(0);" (click)="toggleViewMore()" *ngIf="isLargeComment && !viewMore">
    View more <i class="fas fa-chevron-down"></i>
  </a>

  <a href="javascript:void(0);" (click)="toggleViewMore()" *ngIf="isLargeComment && viewMore">
    Close <i class="fas fa-chevron-up"></i>
  </a>
</div>
